(function () {
    'use strict';

    var Charter = require('../../modules/Charter');
    var $feedbackByAgent = $('#feedback-by-agent');

    if ($feedbackByAgent.length > 0) {
        var feedbackByAgent = greenmotion.reports.feedbackByAgent;

        Charter.bar($feedbackByAgent, feedbackByAgent.labels, [feedbackByAgent.results.questionnaire]);

        require('../../components/feedback/FeedbackAverages');
    }
})();
